// Copyright (c) 2018 Deere & Company

export default Object.freeze({
    PUSH_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMN: 'PUSH_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMN',
    PUSH_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_COLUMN: 'PUSH_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_COLUMN',
    REMOVE_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMN: 'REMOVE_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMN',
    REMOVE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_COLUMN: 'REMOVE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_COLUMN',
    RESET_EXPORT_TO_EXCEL_LAYOUT: 'RESET_EXPORT_TO_EXCEL_LAYOUT',
    RESET_EXPORT_TO_EXCEL_SELECTED_LAYOUT: 'RESET_EXPORT_TO_EXCEL_SELECTED_LAYOUT',
    UPDATE_EXCEL_LAYOUTS: 'UPDATE_EXCEL_LAYOUTS',
    UPDATE_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMNS: 'UPDATE_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMNS',
    UPDATE_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMNS_ORDER: 'UPDATE_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMNS_ORDER',
    UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT: 'UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT',
    UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_COLUMNS_ORDER: 'UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_COLUMNS_ORDER',
    UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_IS_DEFAULT: 'UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_IS_DEFAULT',
    UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_LIST_ID: 'UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_LIST_ID',
    UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_SORT_BY: 'UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_SORT_BY',
    UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_SORT_DIRECTION: 'UPDATE_EXCEL_LAYOUT_MODAL_EXCEL_LAYOUT_SORT_DIRECTION',
    UPDATE_EXCEL_LAYOUT_MODAL_IS_NAME_VALID: 'UPDATE_EXCEL_LAYOUT_MODAL_IS_NAME_VALID',
    UPDATE_EXCEL_LAYOUT_MODAL_IS_NEW_LAYOUT: 'UPDATE_EXCEL_LAYOUT_MODAL_IS_NEW_LAYOUT',
    UPDATE_EXCEL_LAYOUT_MODAL_LAYOUT_NAME: 'UPDATE_EXCEL_LAYOUT_MODAL_LAYOUT_NAME',
    UPDATE_EXCEL_LAYOUT_MODAL_VISIBILITY: 'UPDATE_EXCEL_LAYOUT_MODAL_VISIBILITY',
    UPDATE_SELECTED_EXCEL_LAYOUT: 'UPDATE_SELECTED_EXCEL_LAYOUT'
});



// WEBPACK FOOTER //
// ./src/shared/export-to-excel-actions-list.js